import { useMemo } from 'react'
import { HStack, Image, Link } from '@chakra-ui/react'
import { buildAssetUrlString, getDevice, getOS, openApp } from '@!/Util'
import googlePlayBadgeImage from '@images/google_play_badge.webp'
import appleStoreBadgeImage from '@images/apple_store_badge.webp'

export const AppStoreBadges = () => {
  const os = useMemo(() => getOS(), [])
  const device = useMemo(() => getDevice(), [])

  if (device === 'pc') return null

  const handleOpenApp = () => {
    openApp(os)
  }

  return (
    <HStack p={4} w="100%" justifyContent="center">
      <Link as="button" type="button" onClick={handleOpenApp} display="inline-block">
        <Image src={buildAssetUrlString(appleStoreBadgeImage)} alt="App Store で手に入れよう" height="40px" />
      </Link>
      <Link as="button" type="button" onClick={handleOpenApp} display="inline-block">
        <Image src={buildAssetUrlString(googlePlayBadgeImage)} alt="Google Play で手に入れよう" height="40px" />
      </Link>
    </HStack>
  )
}
